export const workspaceRoutes = [
    {
        path: '/workspaces',
        name: 'workspaces.global',
        component: () => import('@/pages/admin/workspaces/Index.vue'),
        meta: { layoutless: true },
    },
    {
        path: '/:tenantId/workspaces',
        name: 'workspaces.index',
        component: () => import('@/pages/admin/workspaces/Index.vue'),
    },
    {
        path: '/apps',
        name: 'apps.global',
        redirect: to => ({ name: 'workspaces.global', query: to.query, hash: to.hash }),
    },
]
